export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-9d8be4c9fe3cdb6b535643e7a9cd414a.jpg";